import React from 'react';

const CardTitle = ({project, lastUpdate, checked, onChange}) => {
    return (
        <div className="flex flex-col items-start lg:grid grid-cols-12">
            <b className="col-span-4">{project?.name}</b>

            <p className="col-span-4 text-center">Atualização do NOC: {lastUpdate}</p>

            <div className="input-check col-span-4 text-end">
                <input
                    type="checkbox" id="navigate" checked={checked}
                    className="text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-0 cursor-pointer"
                    onChange={({target: {checked}}) => onChange(checked)}
                />
                <label htmlFor="navigate" className="ml-2 text-gray-700 cursor-pointer select-none">
                    Navegar entre as cidades
                </label>
            </div>
        </div>
    );
};

export default CardTitle;